import React from 'react';
/* External */

/* Ott-common */
import Icon from '@dtvgo/icon';
// import { useIntl } from 'react-intl';

/* Components */
import MenuButton from '../MenuButton/MenuButton';

/* Styles */
import './EpisodesButton.scss';

function EpisodesButton() {
  // const { formatMessage } = useIntl();

  return (
    <MenuButton
      onClick={() => {}}
      showOnClick={false}
      buttonContent={(
        <div className="dtv-episodes-content-button">
          <Icon name="episode" />
          {/* <div className="dtv-episodes-tooltip">
            {formatMessage({ id: 'player.episodes' })}
          </div> */}
        </div>
        )}
      className="dtv-common-c-episodes-button"
    />
  );
}

export default EpisodesButton;
